var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2029_14404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 2.05225C4.31999 2.05225 1.33333 5.03891 1.33333 8.71891C1.33333 12.3989 4.31999 15.3856 8 15.3856C11.68 15.3856 14.6667 12.3989 14.6667 8.71891C14.6667 5.03891 11.68 2.05225 8 2.05225ZM6.19333 11.5789L3.79999 9.18558C3.53999 8.92558 3.53999 8.50558 3.79999 8.24558C4.05999 7.98558 4.48 7.98558 4.74 8.24558L6.66666 10.1656L11.2533 5.57891C11.5133 5.31891 11.9333 5.31891 12.1933 5.57891C12.4533 5.83891 12.4533 6.25891 12.1933 6.51891L7.13333 11.5789C6.87999 11.8389 6.45333 11.8389 6.19333 11.5789Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2029_14404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.718994)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleWhite);
export default __webpack_public_path__ + "static/media/checkCircleWhite.bb3d2ac61783a95c01b66dc647e3e7e2.svg";
export { ForwardRef as ReactComponent };